import moment from "moment";

const { TYPES } = require("./notification.type");

// :::::::::; LOCAL ::::::::::
export const setNotification =
  ({ type, message }) =>
  (dispatch) => {
    setNotificationSuccess(dispatch, { type, message });
  };

export const messageSuccess =
  ({ message }) =>
  (dispatch) => {
    const time = moment()?.valueOf();
    setNotificationSuccess(dispatch, { type: "success", message, time });
  };

export const messageError =
  ({ message }) =>
  (dispatch) => {
    const time = moment()?.valueOf();
    setNotificationSuccess(dispatch, { type: "error", message, time });
  };

export const messageWarning =
  ({ message }) =>
  (dispatch) => {
    const time = moment()?.valueOf();
    setNotificationSuccess(dispatch, { type: "warning", message, time });
  };

// :::::::::: dispatch :::::::
const setNotificationSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_NOTIFICATION,
    payload: data,
  });
};
